/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Template({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3.9 6.75a.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 0 1.2h-3a.6.6 0 0 1-.6-.6" /><path fill="currentColor" fillRule="evenodd" d="M4.5 8.65a.6.6 0 0 0-.6.6v2.5a.6.6 0 0 0 .6.6h7a.6.6 0 0 0 .6-.6v-2.5a.6.6 0 0 0-.6-.6zm.6 2.5v-1.3h5.8v1.3z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M1.4 3A2.6 2.6 0 0 1 4 .4h4.672a2.6 2.6 0 0 1 1.838.762l3.329 3.328a2.6 2.6 0 0 1 .761 1.838V13a2.6 2.6 0 0 1-2.6 2.6H4A2.6 2.6 0 0 1 1.4 13zM4 1.6A1.4 1.4 0 0 0 2.6 3v10A1.4 1.4 0 0 0 4 14.4h8a1.4 1.4 0 0 0 1.4-1.4V7.1h-2.9a2.6 2.6 0 0 1-2.577-2.25H4.5a.6.6 0 1 1 0-1.2h3.4V1.6zm5.1 2.9a1.4 1.4 0 0 0 1.4 1.4h2.833a1.4 1.4 0 0 0-.343-.562L9.662 2.01a1.4 1.4 0 0 0-.562-.343z" clipRule="evenodd" /></svg>;
}
;